import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild } from '@angular/router';
import { environment } from '../../../environments_mc/environment';
import { CordovaNetworkInformationPluginService } from '@mono-repo/plugins';
import { SystemEnvironment } from '@mono-repo/data';
import { LoadingIndicatorService } from '@mono-repo/loader';

@Injectable({
  providedIn: 'root',
})
export class BadConnectionGuard implements CanActivate, CanActivateChild {
  constructor(
    private router: Router,
    private networkInformationPlugin: CordovaNetworkInformationPluginService,
    private loadingIndicator: LoadingIndicatorService,
  ) {}

  /**
   * The actual Guard Logic Handler. Either reroutes the client, or returns true.
   *
   * @remarks This is a separate function, because it applies to both canActivate() and canActivateChild().
   */
  private badConnectionHandler() {
    if (
      environment.systemEnvironment === SystemEnvironment.APP &&
      this.networkInformationPlugin.deviceHasSlowConnection()
    ) {
      setTimeout(() => this.loadingIndicator.hide(), 1); // Needed because sometimes the app gets stuck with the loading indicator on. The setTimeout is to prevent racing conditions.
      return this.router.parseUrl('/badConnection');
    } else {
      return true;
    }
  }

  canActivate() {
    return this.badConnectionHandler();
  }

  canActivateChild() {
    return this.badConnectionHandler();
  }
}
